import * as React from 'react';

const Lock24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M12.75 13.75a.75.75 0 0 0-1.5 0v2.5a.75.75 0 0 0 1.5 0z" }), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M7.113 3.48C6.363 4.688 6.068 6.688 6.01 8h-.26A2.75 2.75 0 0 0 3 10.75v7.5A4.75 4.75 0 0 0 7.75 23h8.5A4.75 4.75 0 0 0 21 18.25l-.001-7.5A2.75 2.75 0 0 0 18.249 8h-.26c-.058-1.311-.351-3.311-1.102-4.52C16.011 2.067 14.28 1 12 1S7.989 2.068 7.113 3.48m1.274.79C9.011 3.266 10.28 2.5 12 2.5s2.989.765 3.613 1.77c.566.912.817 2.594.873 3.73H7.512c.056-1.136.31-2.818.875-3.73M5.75 9.5h12.5c.69 0 1.25.56 1.25 1.25l.001 7.5a3.25 3.25 0 0 1-3.25 3.25h-8.5a3.25 3.25 0 0 1-3.25-3.25l-.001-7.5c0-.69.56-1.25 1.25-1.25"
  }
));
Lock24.Size = 24;
Lock24.Title = "Lock";

export { Lock24 as default };
